<div class="loading-screen-wrapper" *ngIf="loading">
  <div class="loading-screen-icon">
    <mat-spinner diameter="60"></mat-spinner>
  </div>
</div>
